<script lang="ts">
  import type { Element } from '$data/types';
  let {
    el,
    sizePct = 70,
    compact = false
  }: { el: Element | undefined | null; sizePct?: number; compact?: boolean } = $props();
</script>

{#if el}
  {#if el.display === 'svg' && el.svg}
    <svg
      viewBox="0 0 100 100"
      style:color={el.color}
      style:width="{sizePct}%"
      style:height="{sizePct}%"
    >
      {@html el.svg}
    </svg>
  {:else if el.display === 'swatch'}
    <span class="elem-swatch" style:background={el.color}></span>
  {:else}
    <span
      class="elem-text"
      style:--label-glow={el.color || 'rgba(0,0,0,0.4)'}
    >
      {compact && el.short ? el.short : el.label}
    </span>
  {/if}
{/if}

<style>
  .elem-text {
    display: block;
    font-weight: 900;
    letter-spacing: -0.03em;
    line-height: 1;
    text-align: center;
    padding: 2px;
    word-break: break-word;
    hyphens: none;
    /* High-contrast white fill with a dark "ink" stroke so the label reads
       on any tile gradient. The assigned color (var --label-glow, set inline)
       becomes a soft halo so each tile keeps its individual identity without
       sacrificing legibility. */
    color: #ffffff;
    -webkit-text-stroke: 1px rgba(0, 0, 0, 0.6);
    text-shadow:
      0 1px 2px rgba(0, 0, 0, 0.85),
      0 0 8px var(--label-glow, rgba(0, 0, 0, 0.4));
    paint-order: stroke fill;
    -webkit-font-smoothing: antialiased;
    text-rendering: geometricPrecision;
  }
  :global(body.brutal) .elem-text {
    color: var(--text);
    -webkit-text-stroke: 0;
    text-shadow: none;
  }
  .elem-swatch {
    display: block;
    width: 64%;
    height: 64%;
    border-radius: var(--radius-sm);
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.14),
      0 4px 12px rgba(0, 0, 0, 0.3);
  }
  :global(body.brutal) .elem-swatch {
    border-radius: 0;
    box-shadow: 2px 2px 0 0 var(--text);
    border: 2px solid var(--text);
  }
</style>
